import useCustomerData from "../hooks/useCustomerData";
import { useEntityImageLookup } from "../hooks/useEntityImageLookup";
import { useLoyaltyTierTheme } from "../hooks/loyalty/useLoyaltyTierTheme";
import useFranchiseData from "../hooks/useFranchiseData";
import useLinkOffers from "../hooks/useLinkOffers";
import { useLoyaltyDataRefetch } from "../hooks/useLoyaltyDataRefetch";
import { useReleaseAbandonedPayment } from "../hooks/useReleaseAbandonedPayment";
import useRestaurantData from "../hooks/useRestaurantData";

// Memoized by parent BackgroundManager
const BackgroundHooks = () => {
  useCustomerData();
  useRestaurantData();
  useEntityImageLookup();
  useFranchiseData();
  useLinkOffers();
  useLoyaltyDataRefetch();
  useLoyaltyTierTheme();
  useReleaseAbandonedPayment();

  return null;
};

export default BackgroundHooks;
